import * as React from 'react'
import { DiscountRulesService } from './discountRulesService'

export const DiscountRulesServiceContext = React.createContext(null as any as DiscountRulesService)
